
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airlines/offers",
      function () {
        return require("private-next-pages/airlines/offers.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airlines/offers"])
      });
    }
  